export default __webpack_public_path__ + "static/events-dark-9967df126e53c4e7896f2729cb299209.png";